import { mountVueWithPinia, mountVue } from '../vue/mountVue';
import { audienceLibrary, waitForDYObject } from '@utils/global-functions';
import { determineRecommendation } from '@utils/ProductResources';
import ProductGrid from '../vue/ProductCards/ProductGrid.vue';
import ProductSlider from '../vue/ProductCards/ProductSlider.vue';

const passJsonAsProp = async (el, content) => {
  const data = JSON.parse(content) ?? false;

  if (!data) return;
  const recommendation = data?.recommendation ?? false;
  if (!recommendation) return el.setAttribute('props-data', content);

  const limit = data?.limit_recommendations ?? false;
  data.items = await determineRecommendation(recommendation, limit);
  return el.setAttribute('props-data', JSON.stringify(data));
};

export class ProductGrids extends HTMLElement {
  constructor(context) {
    super();
    if (context) this.mountProductCards(context);
  }
  async mountProductCards(context) {
    //if the in page navigation module exists on a landing page or PLP, prevent auto scrolling to the top of the page on load
    if (!document.querySelector('.page-navigation')) window.scrollTo(0, 0);

    const app = context.querySelector('.js-product-grid');
    const jsonScript = context.querySelector('.js-product-grid-json');
    if (!app || !jsonScript) return;
    await passJsonAsProp(app, jsonScript.innerHTML);
    mountVueWithPinia('.js-product-grid', ProductGrid, context);
  }
}

export class ProductSliders extends HTMLElement {
  constructor(context) {
    super();
    if (context) this.mountProductCards(context);
  }
  async mountProductCards(context) {
    const app = context.querySelector('.js-product-slider');

    //if the product slider is powered by DY audiences, wait for the audience DY data to come in, then grab the correct audience specific JSON to mount Vue.
    if (context.classList.contains('audience-strategies')) {
      waitForDYObject()
        .then((obj) => {
          const matchedAudience = audienceLibrary.filter((audience) => obj.audiences.includes(audience.id))?.[0];
          //if DY does not load, just default recommendations to the low intent strategy
          const audienceId = matchedAudience.index || 1;
          return context.querySelector(`.js-product-slider-json[data-audience="${audienceId}"]`);
        })
        .then((recommendationData) => {
          mountDYAudienceRecommendations(app, context, recommendationData);
        });
    }
    //mount product cards regularly
    else {
      const jsonScript = context.querySelector('.js-product-slider-json');
      if (!app || !jsonScript) return;
      await passJsonAsProp(app, jsonScript.innerHTML);
      mountVueWithPinia('.js-product-slider', ProductSlider, context);
    }
  }
}

const mountDYAudienceRecommendations = async (app, context, jsonScript) => {
  await passJsonAsProp(app, jsonScript.innerHTML);
  mountVueWithPinia('.js-product-slider', ProductSlider, context);
};

customElements.define('product-grid', ProductGrids);
customElements.define('product-slider', ProductSliders);
